import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '@core/services/user/user.service';
import { Client } from '@core/services/client/client.model';
import { ClientService } from '@core/services/client/client.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';
import { UserPreferences } from '@core/services/user/user.model';
import {
  UserAction,
  WorkQueueDetails,
  WorkQueueModel,
  WorkQueueUpdateModel,
  GridCriteriaModel
} from '@core/services/work-queue/work-queue.model';
import { WorkQueueService } from '@core/services/work-queue/work-queue.service';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { process } from '@progress/kendo-data-query';
import {
  ComponentGridSettings,
  FeatureComponentGridSettings,
  GridSettings
} from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { forkJoin, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'Teranet-LenderReconciliationQueue',
  templateUrl: './lenderreconciliation-queue.component.html'
})
export class LenderReconciliationQueueComponent implements OnInit {
  @Input() WorkQueueType: number;
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;

  queues$: Observable<WorkQueueDetails>;

  accountUpdates: number = 0;
  allStatuses: number = 0;
  clientInfoId: number;
  completeStatuses: number = 0;
  componentPreferences: ComponentGridSettings[] = [];
  constructorName: string;
  customerFollowUps: number = 0;
  featureComponentGridSettings: FeatureComponentGridSettings = new FeatureComponentGridSettings();
  filterConditions: string = 'all';
  assignedStatusId: number = -1;
  workqueueStatusId: number = -1;
  intialGridSettings: GridSettings;
  isExternalUser: boolean = true;
  isFinishLoading: boolean = false;
  isHideRepo: boolean = true;
  newStatuses: number = 0;
  underViewStatuses: number = 0;
  accountUpdateStatus: number =-1;
  customerfollowupStatus: number=-1;
  insurancefollowupStatus: number=-1;
  investigationStatus: number =-1;
  lenderReconciliationModel: WorkQueueModel[] = [];
  queues: WorkQueueDetails = new WorkQueueDetails();
  routerName: string;
  rejectedStatuses: number = 0;
  public spinnerName: string = 'LenderReconciliationQueueSpinner';

  public gridSettings: GridSettings;
  public queueName: string = 'LenderReconciliation';
  public state: any = {
    skip: 0,
    take: 13,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  workQueueUpdateModel: WorkQueueUpdateModel = new WorkQueueUpdateModel();

  constructor(
    private clientService: ClientService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private workQueueService: WorkQueueService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
    this.routerName = this.route.routeConfig.component.name;
    this.constructorName = this.constructor.name;
    this.featureComponentGridSettings.routerName = this.routerName;
    this.featureComponentGridSettings.featureName = this.constructorName;
    this.lenderReconciliationModel = [];

    this.clientInfoId = this.localStorageService.getItem('currentUser')
      ? this.localStorageService.getItem('currentUser').corporationid >= 0
        ? this.localStorageService.getItem('currentUser').corporationid
        : -1
      : -1;

    if (this.clientInfoId === 0) {
      this.isExternalUser = false;
    }

    this.intialGridSettings = this.workQueueService.GetDefaultGridSetting(this.state, this.lenderReconciliationModel);
    this.gridSettings = this.intialGridSettings;
    this.spinner.show();
    this.userService.getUserDashboardPreferences(this.routerName).subscribe(r => {
      if (r != undefined) {
        let componentGridSettings: ComponentGridSettings;
        this.componentPreferences = (r as any) as ComponentGridSettings[];
        if (this.componentPreferences.find(r => r.componentName === this.constructor.name) != undefined) {
          componentGridSettings = this.componentPreferences.find(r => r.componentName === this.constructor.name);
          this.filterConditions = componentGridSettings.customizedSettings;
        }    
      }
      this.refresh();
    });
  }
  
  public onFilterClick(name: string): void {
    this.spinner.show(this.spinnerName);

    this.filterConditions = name;
    this.gridSettings.state.skip = 0;
    const gridCriteria: GridCriteriaModel = {
      customizedSetting: this.filterConditions,
      key: this.WorkQueueType.toString(),
      gridSetting: JSON.stringify(this.gridSettings, function replacer(key, value) {
        if (key === 'gridData') {
          return { data: [], total: 0 };
        }
        else {
          return value;
        }
      })
    }
    this.componentPreferences.find(p => p.componentName === this.constructorName).customizedSettings = this.filterConditions;
    this.saveUserPreferences();
    this.refresh();
  }
      
  refresh() { 
    switch (this.filterConditions) {
      case 'all':
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = -1;
        break;
      case 'new':
        this.workqueueStatusId = 1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = -1;
        break;
      case 'under review':
        this.workqueueStatusId = 2;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = -1;
        break;
      case 'complete':
        this.workqueueStatusId = 3;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = -1;
        break;
      case 'account update':
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = 0;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = 1;
        break;
      case 'customer followup':
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = 0;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = 2;
        break;
      case 'insurance followup':
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = 0;
        this.investigationStatus = -1;
        this.assignedStatusId = 3;
        break;
      case 'investigation':
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = 0;
        this.assignedStatusId = 4;
        break;
      default:
        this.workqueueStatusId = -1;
        this.accountUpdateStatus = -1;
        this.customerfollowupStatus = -1;
        this.insurancefollowupStatus = -1;
        this.investigationStatus = -1;
        this.assignedStatusId = -1;
    };    
    const getUserDashboardPreferences = this.userService.getUserDashboardPreferences(
      this.routerName
    );
    const getLenderReconciliationQueue = this.workQueueService.GetWorkQueue(this.WorkQueueType, this.workqueueStatusId, this.accountUpdateStatus, this.customerfollowupStatus, this.investigationStatus, this.insurancefollowupStatus);
    const getCurrentClient = this.clientService.getCurrentClient();

    forkJoin([getUserDashboardPreferences, getLenderReconciliationQueue, getCurrentClient]).subscribe(
      responses => {
        let isDefaultGrid: boolean = false;
        let componentGridSettings: ComponentGridSettings;
        if (responses[0] && responses[0].length > 0) {
          this.componentPreferences = (responses[0] as any) as ComponentGridSettings[];

          if (
            this.componentPreferences.find(r => r.componentName === this.constructor.name) !=
            undefined
          ) {
            componentGridSettings = this.componentPreferences.find(
              r => r.componentName === this.constructor.name
            );
          } else {
            isDefaultGrid = true;
          }
        } else {
          isDefaultGrid = true;
        }
        if (isDefaultGrid) {
          this.filterConditions = 'all';
          componentGridSettings = new ComponentGridSettings();
          componentGridSettings.componentName = this.constructorName;
          componentGridSettings.customizedSettings = this.filterConditions;
          componentGridSettings.gridSettings = [];
          componentGridSettings.gridSettings.push(this.intialGridSettings);
          this.componentPreferences.push(componentGridSettings);
        }
        this.featureComponentGridSettings.componentGridSettings = this.componentPreferences;

        // if (
        //   componentGridSettings.customizedSettings != null &&
        //   componentGridSettings.customizedSettings != undefined
        // ) {
        //   this.filterConditions = componentGridSettings.customizedSettings;
        // }

        this.queues = responses[1] as WorkQueueDetails;
        var currentClient = responses[2] as Client;
        if (currentClient) {
          if (this.clientInfoId === 0) {
            // Teranet User
            this.isHideRepo = false;
          } else {
            this.isHideRepo = true;
          }
        }
        this.lenderReconciliationModel = this.queues?.workQueueModels;
        this.gridSettings.gridData = { data: this.queues?.workQueueModels, total: this.queues?.workQueueModels?.length };

        let hasChange = this.resetCustomizedGrid(isDefaultGrid);
        if (hasChange) {
          this.saveUserPreferences();
        }
        this.gridSettings.gridData = { data: this.queues?.workQueueModels, total: this.queues?.workQueueModels?.length };
        this.spinner.hide();
        this.isFinishLoading = true;
      }
    );
  }

  resetCustomizedGrid(isDefaultGrid: boolean): boolean {
    let hasChange: boolean = false;

    // For Default Grid Reset
    

    // For Default Value Reset
    if (isDefaultGrid) {
      hasChange = true;

      
      if (this.componentPreferences && this.componentPreferences.length > 0) {
        this.componentPreferences.find(
          p => p.componentName === this.constructor.name
        ).gridSettings[0] = this.gridSettings;
      }
    } else {

      // If new column is added
      this.gridSettings.columnsConfig.forEach(column => {
        if (
          this.componentPreferences
            .find(p => p.componentName === this.constructor.name)
            .gridSettings[0].columnsConfig.find(x => x.field == column.field) == null
        ) {
          hasChange = true;
          this.componentPreferences
            .find(p => p.componentName === this.constructor.name)
            .gridSettings[0].columnsConfig.push(column);
        }
      });
      // If existed column is removed from default grid SettingsService - TO DO => Clear the requirement, whether it requires to confirm with user
      // If default grid setting got changed, so User Preferenace need to update - TO DO

      // Read User Preferences & Reset the Grid
      if (this.componentPreferences && this.componentPreferences.length > 0) {
        this.gridSettings = this.componentPreferences.find(
          p => p.componentName === this.constructor.name
        ).gridSettings[0];
      }
    }

    // Remove Data from saving to minimize the DB storage
    if (hasChange && this.componentPreferences && this.componentPreferences.length > 0) {
      if (
        this.componentPreferences.find(p => p.componentName === this.constructor.name) &&
        this.componentPreferences.find(p => p.componentName === this.constructor.name)
          .gridSettings[0]
      ) {
        let gridData = { data: [], total: 0 };
        this.componentPreferences.find(
          p => p.componentName === this.constructor.name
        ).gridSettings[0].gridData = gridData;
      }
    }
    return hasChange;
  }

  saveUserPreferences() {
   const userPreferences: UserPreferences = {
     dashboardComponentName: this.routerName,
     dashboardPreferences: JSON.stringify(this.componentPreferences),
   };
   this.userService.createOrUpdateUserDashboardPreferences(userPreferences).subscribe();
  }
}
